import CheckedError from "./CheckedError";
export default class BinaryValueOutOfRange extends CheckedError {
    constructor(value, bits) {
        super(`Value ${value} out of ${bits}-bit valid range`);
    }
}
